import { Money } from '../../../../types';

export const subtractMoney = (minuend: Money, subtrahend: Money | null | undefined): Money => ({
	amount: (minuend.amount ?? 0) - (subtrahend?.amount ?? 0),
	currency: minuend.currency ?? subtrahend?.currency
});
